import React from "react";
import { TitleBlock, Field, Actions, PrimaryBtn, SegmentedControl } from "../../../../auth/v2/pieces";
import { SPORTS, GENDERS } from "../../../../ForBusiness/Cacheshare/taxonomy";
import { ChoiceChips } from "../coachOnboardingPieces";
import { canContinue } from "../coachOnboardingModel";

const GENDER_OPTIONS = GENDERS.map((g) => [g.value, g.name]);

// 05 · Sport and gender. Football has no gender split, so the control hides.
const SportStep = ({ firstName, filters, onChange, onContinue }) => (
  <>
    <TitleBlock
      eyebrow="Sport"
      title="What do you coach?"
      sub={`Welcome${firstName ? `, ${firstName}` : ""}. We'll walk through sport, tier, league, and team, then match you to your roster.`}
    />
    <Field label="Sport">
      <ChoiceChips label="Sport" options={SPORTS} value={filters.sport?.value} onChange={(v) => onChange({ sport: SPORTS.find((s) => s.value === v) || null })} />
    </Field>
    {filters.sport?.hasGender && (
      <Field label="Gender">
        <SegmentedControl label="Gender" options={GENDER_OPTIONS} value={filters.gender?.value} onChange={(v) => onChange({ gender: GENDERS.find((g) => g.value === v) || null })} />
      </Field>
    )}
    <Actions>
      <PrimaryBtn disabled={!canContinue("sport", filters)} onClick={onContinue}>
        Continue
      </PrimaryBtn>
    </Actions>
  </>
);

export default SportStep;
